import companies from "./companies";
import freelancer from "./freelancer";

export default {
  en: {
    // Subpages
    freelancer: freelancer.en,
    companies: companies.en,
  },
  de: {
    // Subpages
    freelancer: freelancer.de,
    companies: companies.de,
  },
};
